@import '../../../../../../../constants/spacing.module.less';
@import 'ui-components/components/text/text.module.less';

.dangerous-goods-section {
  gap: @space-16;
}

.dangerous-goods-checkbox-container {
  align-items: center;
}

.dangerous-goods-checkbox {
  .paragraph;
  height: inherit;
}

.learn-more-link {
  margin-left: @space-8;
  display: flex;

  svg {
    width: 12px;
    margin-left: @space-4;
  }
}
